import { render, staticRenderFns } from "./ForecastView.vue?vue&type=template&id=36f70f82&scoped=true"
import script from "./ForecastView.vue?vue&type=script&lang=js"
export * from "./ForecastView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f70f82",
  null
  
)

export default component.exports